import { render, staticRenderFns } from "./ReminderTabComponent.vue?vue&type=template&id=7883104e&scoped=true"
import script from "./ReminderTabComponent.js?vue&type=script&lang=js&external"
export * from "./ReminderTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./ReminderTabComponent.vue?vue&type=style&index=0&id=7883104e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7883104e",
  null
  
)

export default component.exports